import { TFunction } from "i18next";
import { z } from "zod";

import { isValidPassword } from "../utils/isValidPassword";

export const createResetPasswordFormSchema = (t: TFunction) =>
  z
    .object({
      password: z
        .string()
        .min(1, t("resetPassword.errors.passwordRequired"))
        .superRefine((value, ctx) => {
          const result = isValidPassword(value);
          if (result.valid) return;

          const messageByReason: Record<string, string> = {
            too_short: t("resetPassword.errors.passwordTooShort"),
            no_letters: t("resetPassword.errors.passwordNoLetters"),
            no_numbers: t("resetPassword.errors.passwordNoNumbers"),
            no_letters_or_numbers: t(
              "resetPassword.errors.passwordNoLettersOrNumbers",
            ),
          };

          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message:
              messageByReason[result.reason ?? ""] ??
              t("resetPassword.errors.passwordInvalid"),
          });
        }),
      confirmPassword: z
        .string()
        .min(1, t("resetPassword.errors.confirmPasswordRequired")),
    })
    .refine((data) => data.password === data.confirmPassword, {
      message: t("resetPassword.errors.passwordsDoNotMatch"),
      path: ["confirmPassword"],
    });
